export function ChevronIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
      <path
        d="M0.583252 9.45573L6.99992 3.03906L13.4166 9.45573L11.9131 10.9592L6.99992 6.04607L2.08676 10.9592L0.583252 9.45573Z"
        fill="black"
      />
    </svg>
  );
}
